import { isMobileDevice } from '../device';

export enum ShareMethod {
    Native = 'native',
    Clipboard = 'clipboard',
    None = 'none',
}

export type ShareData = {
    url: string;

    title?: string;
    text?: string;
};

export type ShareResult = {
    success: boolean;
    method: ShareMethod;
    error?: string;
};

/**
 * Открывает нативный диалог "Поделиться" на мобильных устройствах.
 * На десктопах сразу копирует URL в буфер обмена.
 */
export async function shareUrl(data: ShareData): Promise<ShareResult> {
    const { title, text, url } = data;
    const content = [title, url, text].filter(Boolean).join('\n\n');

    // Используем нативный шеринг только на мобильных устройствах
    if (navigator.share && isMobileDevice()) {
        try {
            await navigator.share({ text: content });

            return {
                success: true,
                method: ShareMethod.Native,
            };
        } catch (error) {
            // Пользователь отменил шеринг или произошла ошибка
            if (error instanceof Error && error.name === 'AbortError') {
                // Пользователь отменил - это не ошибка
                return {
                    success: false,
                    method: ShareMethod.None,
                    error: 'Пользователь отменил шеринг',
                };
            }

            // Реальная ошибка - пробуем fallback
            console.error('Ошибка Web Share API:', error);
        }
    }

    // Fallback: копируем URL в буфер обмена
    try {
        await navigator.clipboard.writeText(url);

        return { success: true, method: ShareMethod.Clipboard };
    } catch (error) {
        console.error('Ошибка копирования в буфер обмена:', error);

        return { success: false, method: ShareMethod.None, error: 'Не удалось скопировать ссылку' };
    }
}
